export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/utils/ownerDocument.js
// module id = 132
// module chunks = 2